const getTabValue = ({ value }, index) => value ?? index;

// The optimistic value trails the `value` prop by one render. If the tab list changes in that same
// render (e.g. a tab is hidden once async loan data resolves), the stale value can match no tab, so
// fall back to `value`, which the parent keeps inside the current tab list.
export const getActiveTabValue = ({ tabs, optimisticValue, value }) =>
  tabs.some((tab, index) => getTabValue(tab, index) === optimisticValue) ? optimisticValue : value;
